import { render, staticRenderFns } from "./forgotten-password.vue?vue&type=template&id=5dab7d3d&"
import script from "./forgotten-password.vue?vue&type=script&lang=js&"
export * from "./forgotten-password.vue?vue&type=script&lang=js&"
import style0 from "./forgotten-password.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports